import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Home from "../Pages/Home";
import Loader from "./ReusableComponents/Loader";


const ProtectedGeneratorRoute = ({ darkMode }) => {
  const { user, loading, subscriptionActive, subscriptionLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait until both auth and subscription are done loading
    if (loading || subscriptionLoading) return;

    const path = location.pathname;
    const hasDuoColor = path.includes('&D');
    const hasTrioColor = path.includes('&T');

    if (!subscriptionActive && (hasDuoColor || hasTrioColor)) {
      const monoColorMatch = path.match(/\/generator\/([a-fA-F0-9]{6})/);
      if (monoColorMatch) {
        navigate(`/generator/${monoColorMatch[1]}`, { replace: true });
      } else {
        navigate('/generator', { replace: true });
      }
    }
  }, [user, loading, subscriptionActive, subscriptionLoading, location.pathname, navigate]);

  // if (loading || subscriptionLoading) {
  //   return <Loader />;
  // }

  return <Home darkMode={darkMode} />;
};

export default ProtectedGeneratorRoute;
